<div class="body" [formGroup]="formGroup">

    <div class="sidenav-wrapper">

        <app-sidenav></app-sidenav>

    </div>

    <div @show class="content">

        <div class="content-row-2">

            <div class="section-wrapper address-wrapper">

                <div class="section-headline optional">

                    <mat-icon class="main-icon">location_on</mat-icon>

                    <span class="text">
                        Anschrift des Standorts
                    </span>

                    <span class="spacer"></span>

                    <button *ngIf="addressControl.valid" mat-icon-button matTooltip="Adresse auf Karte anzeigen" (click)="showAddress()">
                        <mat-icon>map</mat-icon>
                    </button>

                </div>

                <div class="address-form-wrapper">

                    <app-address-form formGroupName="address" style="margin-right: 1rem; flex: 1; width: 100%; overflow: hidden;"></app-address-form>

                    <app-concurrency-label [entityIsSupported]="false"></app-concurrency-label>

                </div>

            </div>

            <div class="section-wrapper" formGroupName="location">

                <div class="section-headline optional">

                    <mat-icon class="main-icon">edit_location</mat-icon>

                    <span class="text">
                        Weitere Standortangaben
                    </span>

                    <span class="spacer"></span>

                </div>

                <div class="location-form-wrapper">

                    <app-location-form appearance="outline"></app-location-form>

                </div>
            </div>

        </div>

        <div>

            <div class="section-wrapper">

                <div class="section-headline optional">

                    <mat-icon class="main-icon">rule</mat-icon>

                    <span class="text">
                        Verfügbare Komponenten
                    </span>

                    <span class="spacer"></span>

                </div>

                <div class="location-availability-table-wrapper">

                    <app-location-availability-table *ngIf="!reset" [editMode]="!disabled" formArrayName="availabilities"></app-location-availability-table>

                </div>

            </div>

        </div>

    </div>

</div>